var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.name != 'GetStarted' && _vm.auth_status)?_c('Navigation_bar'):_vm._e(),(_vm.auth_status)?_c('v-main',[_c('router-view')],1):(!_vm.auth_status)?_c('login'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }